// extracted by mini-css-extract-plugin
export default {"host":"_1BYuegcwxWy3tS5sbg3RVg","trigger":"_15-bP7jyXe9jSYshRdgw_n"};